import React from "react";
// css
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/recent-searches-popup.scss";
var RecentSearchesPopup = function (_a) {
    var searches = _a.searches, onSelect = _a.onSelect;
    return (React.createElement("div", { className: "recent-searches" },
        React.createElement("h3", { className: "txt_blackOne1 DMSans_13_500 mt-1" }, "Recent searches"),
        React.createElement("div", { className: "recent-searches__list" }, searches === null || searches === void 0 ? void 0 : searches.map(function (item, index) { return (React.createElement("div", { key: index, className: "recent-searches__item", onClick: function () { return onSelect(item); } },
            React.createElement("i", { className: "edel-icon-timeout-holding txt_secondary-gray fs-12" }),
            React.createElement("span", { className: "txt_medium-gray DMsanL_12_300" }, item === null || item === void 0 ? void 0 : item.search_txt))); }))));
};
export default RecentSearchesPopup;
